var map = {
	"./cta-block-img.png": "./admin-thumbs/cta-block-img.png",
	"./default.png": "./admin-thumbs/default.png",
	"./s-blocks-grid.png": "./admin-thumbs/s-blocks-grid.png",
	"./s-blocks.png": "./admin-thumbs/s-blocks.png",
	"./s-breadcrumbs.png": "./admin-thumbs/s-breadcrumbs.png",
	"./s-bsport-widget.png": "./admin-thumbs/s-bsport-widget.png",
	"./s-cta-block.png": "./admin-thumbs/s-cta-block.png",
	"./s-cta.png": "./admin-thumbs/s-cta.png",
	"./s-editor-media.png": "./admin-thumbs/s-editor-media.png",
	"./s-editor.png": "./admin-thumbs/s-editor.png",
	"./s-faq.png": "./admin-thumbs/s-faq.png",
	"./s-form.png": "./admin-thumbs/s-form.png",
	"./s-header-article.png": "./admin-thumbs/s-header-article.png",
	"./s-header-gallery.png": "./admin-thumbs/s-header-gallery.png",
	"./s-header.png": "./admin-thumbs/s-header.png",
	"./s-hero.png": "./admin-thumbs/s-hero.png",
	"./s-intake-popup.png": "./admin-thumbs/s-intake-popup.png",
	"./s-list.png": "./admin-thumbs/s-list.png",
	"./s-marquee.png": "./admin-thumbs/s-marquee.png",
	"./s-number-highlights.png": "./admin-thumbs/s-number-highlights.png",
	"./s-page-title.png": "./admin-thumbs/s-page-title.png",
	"./s-post-carousel.png": "./admin-thumbs/s-post-carousel.png",
	"./s-price-table.png": "./admin-thumbs/s-price-table.png",
	"./s-reusable-sections.png": "./admin-thumbs/s-reusable-sections.png",
	"./s-schedule.png": "./admin-thumbs/s-schedule.png",
	"./s-steps.png": "./admin-thumbs/s-steps.png",
	"./s-studio-carousel.png": "./admin-thumbs/s-studio-carousel.png",
	"./s-studios-map.png": "./admin-thumbs/s-studios-map.png",
	"./s-style-carousel.png": "./admin-thumbs/s-style-carousel.png",
	"./s-team-carousel.png": "./admin-thumbs/s-team-carousel.png",
	"./s-team-list.png": "./admin-thumbs/s-team-list.png",
	"./s-testimonial-grid.png": "./admin-thumbs/s-testimonial-grid.png",
	"./s-training-blocks.png": "./admin-thumbs/s-training-blocks.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./admin-thumbs sync recursive \\.png$";